
import React from "react";
import { BookMarked, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

interface HeaderProps {
  onRefresh: () => void;
}

export const SharedNotesHeader: React.FC<HeaderProps> = ({ onRefresh }) => {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-center justify-between">
      <div>
        <h1 className="text-2xl font-bold flex items-center">
          <BookMarked className="h-6 w-6 mr-2" />
          Shared Public Notes
        </h1>
        <p className="text-muted-foreground mt-1">
          Discover and explore public notes shared by other users
        </p>
      </div>

      <div className="flex gap-2">
        <Button
          variant="outline"
          size="icon"
          onClick={onRefresh}
          title="Refresh"
        >
          <RefreshCw className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};
